import type { ProductModelV2 } from '@develop/ia-api-library'

export const useFacebook = () => {
  const userCentrics = useUserCentrics()

  const isLoaded = () => document.getElementById('FacebookPixelScript') != null
  const isAllowedToLoad = computed(() => userCentrics.selectedPublishers.value.find(p => p.name === 'MetaPixel'))

  const checkoutStore = useCheckoutStore()

  const cartStore = useCartStore()

  const cartTotal = computed(() => (checkoutStore.totalPrice?.cost ?? 0) / 100)

  const orderProducts: any[] = []

  cartStore.productsWithDetails?.forEach((product) => {
    orderProducts.push({
      id: product.pzn,
      name: product.name,
      category: product.categories,
    })
  })

  const getProductModelV2Products = (products: any[]) => {
    const results: any[] = []
    products.forEach((product) => {
      results.push({
        pzn: product.pzn,
      })
    })
    return results
  }

  const getFBPixelProductDto = (products: Array<any>) => {
    return products.map((product) => {
      return {
        id: product.pzn,
        quantity: 1,
      }
    })
  }

  const execEvent = (eventType: string, eventName: string, eventParams: any = null) => {
    if ('fbq' in window && isAllowedToLoad.value)
      window.fbq(eventType, eventName, eventParams)
  }

  const pageViewEvent = () => {
    if (isAllowedToLoad.value && isLoaded())
      execEvent('track', 'PageView')
  }

  const viewContentEvent = (product: ProductModelV2) => {
    if (isAllowedToLoad.value && isLoaded())
      execEvent('track', 'ViewContent', {
        contents: getFBPixelProductDto([product]),
        value: product.mainPrice?.value ?? 0,
        currency: 'EUR',
        content_type: 'product',
      })
  }

  const purchaseEvent = () => {
    if (isAllowedToLoad.value && isLoaded())
      execEvent('track', 'ViewContent', {
        contents: getFBPixelProductDto([getProductModelV2Products(cartStore.productsWithDetails)]),
        value: cartTotal,
        currency: 'EUR',
        content_type: 'product',
      })
  }

  const init = async () => {
    if (isAllowedToLoad.value) {
      if (!isLoaded())
        return import('./facebook.js').then(async ({ initFacebook }) => await initFacebook())
      else
        return Promise.resolve()
    }
  }

  return { init, pageViewEvent, viewContentEvent, purchaseEvent }
}
